import { eventSuffix } from "./calUtils";

function MiniMonth({ m, cols, onPick }) {
  return (
    <button type="button" onClick={() => onPick(m.index)} data-testid={`cal-year-month-${m.index}`}
      className="rounded-md border border-[#2D3442] bg-[#13171F]/60 p-3 text-left transition-colors hover:border-[#F59E0B]/60">
      <div className="mb-2 flex items-baseline justify-between">
        <span className="font-display text-lg text-[#F3EBDD]">{m.name}</span>
        <span className="font-mono-lf text-[10px] text-[#A8A090]">{m.days}d</span>
      </div>
      <div className="grid gap-0.5" style={{ gridTemplateColumns: `repeat(${Math.min(cols, 10)}, 1fr)` }}>
        {Array.from({ length: cols <= 10 ? m.first_weekday ?? 0 : 0 }).map((_, i) => <span key={`b${i}`} />)}
        {Array.from({ length: Math.min(m.days, 140) }).map((_, i) => {
          const marks = m.marks[String(i + 1)];
          return (
            <span key={i} className="relative text-center font-mono-lf text-[9px] leading-4 text-[#A8A090]">
              {i + 1}
              {marks && <span className="absolute bottom-0 left-1/2 h-1 w-1 -translate-x-1/2 rounded-full" style={{ background: marks[0] }} />}
            </span>
          );
        })}
      </div>
    </button>
  );
}

export const YearGrid = ({ data, onPickMonth }) => {
  const cols = data.weekdays.length || 7;
  return (
    <div className="space-y-8" data-testid="cal-year-grid">
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {data.months.map((m) => <MiniMonth key={m.index} m={m} cols={cols} onPick={onPickMonth} />)}
      </div>
      <section>
        <div className="lf-label mb-3">This year · {data.events.length} occurrences · {data.year_length} days{data.is_leap ? " · leap year" : ""}</div>
        <div className="divide-y divide-[#2D3442] rounded-md border border-[#2D3442]" data-testid="cal-year-events">
          {data.events.length === 0 && <p className="p-4 text-sm text-[#A8A090]">Nothing recurring this year.</p>}
          {data.events.map((e, i) => (
            <div key={`${e.id}-${i}`} className="flex items-center gap-3 px-4 py-2 text-sm">
              <span className="h-2 w-2 shrink-0 rounded-full" style={{ background: e.color }} />
              <span className="text-[#F3EBDD]">{e.title}<span className="text-[#A8A090]">{eventSuffix(e)}</span></span>
              <span className="ml-auto font-mono-lf text-xs text-[#A8A090]">{e.label}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};
